import LocalProfile from './LocalProfile'


export default LocalProfile
